module.exports = __webpack_public_path__ + "media/images/zl_w2-4398d786a96c066c7ffe93c2891da313.png";